






import { Vue, Component } from 'vue-property-decorator'
import RecentTransactions from '@/components/Home/RecentTransactions.vue'

@Component({
    components: {
        RecentTransactions,
    },
})
export default class Home extends Vue {}
